import { Moment } from 'moment';
import { Raft } from './growth-cycle-template';
import { Farm } from './farm';

export interface ToDo {
    id?: string;
    // These can be a string or a firebase object depending on where we are in the code
    growthCycleId: any;
    growthCycleTemplateId: any;
    varietyName: string;
    taskName: TaskName;
    dueDate: Moment;
    complete: boolean;
    rafts: number;
    cells: number;
    raftType?: Raft;
    harvestInterval?: number;
    // Only used for UI, filtered out before save
    isEditing?: boolean;
    uiDueDate?: string;
    isHarvesting?: boolean;
    harvestAmount?: number;
    farmId: Farm;
}

export enum TaskName {
    START_GERMINATION = 'Start Germination',
    MOVE_TO_PROPAGATION = 'Move to Propagation',
    MOVE_TO_HIGH_DENSITY = 'Move to High Density',
    MOVE_TO_FINISHED_SPACING = 'Move to Finished Spacing',
    HARVEST = 'Harvest',
}
